import { render, staticRenderFns } from "./OneMinute.vue?vue&type=template&id=56db1c62&scoped=true"
import script from "./OneMinute.vue?vue&type=script&lang=js"
export * from "./OneMinute.vue?vue&type=script&lang=js"
import style0 from "./OneMinute.vue?vue&type=style&index=0&id=56db1c62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56db1c62",
  null
  
)

export default component.exports